import { Badge } from "react-bootstrap";
import moment from "moment";
import { useTranslation } from "react-i18next";
import SidebarLink from "./SidebarLink";
import { useAppSelector } from "../../redux/hooks";

const AdvertisingSidebar = ({ applications, small = false }) => {
  const user = useAppSelector((state) => state.user);
  const { t } = useTranslation(["common"]);
  const isActive = (routeName) => {
    return document.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  if (!applications.some((m) => m === "Advertising")) {
    return null;
  }

  const now = moment();
  const tosDate = moment(user?.tos_acceptance_date?.slice(0, 10));
  const daysSinceSignup = tosDate ? now.diff(tosDate, "days") : 100;

  const isAdvertisingDashboardActive =
    isActive("/user/advertising/category") ||
    isActive("/user/advertising/dashboard") ||
    isActive("/user/advertising/advertisement");

  return (
    <SidebarLink
      to={"/user/advertising/dashboard"}
      isActive={isAdvertisingDashboardActive}
      icon={<i className="pe-7s-speaker" />}
      small={small}
      section={"placement"}
    >
      {t(($) => $.common.sidebar.Advertising)}{" "}
      {user.tier === "unknown" && user.pricing_tier === "unknown" && daysSinceSignup < 3 && (
        <Badge
          className={`badge-${isAdvertisingDashboardActive ? "secondary" : "primary"}`}
          style={{ marginLeft: "1rem" }}
          pill
        >
          {t(($) => $.common.sidebar.NEW)}
        </Badge>
      )}
    </SidebarLink>
  );
};

export default AdvertisingSidebar;
